/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Recreate_BtnInputs */

const vi_order_recreate_btn = /** @type {(inputs: Order_Recreate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ và tạo lại`)
};

/**

* @param {Order_Recreate_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_recreate_btn = /** @type {((inputs?: Order_Recreate_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Recreate_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_recreate_btn(inputs)
});